export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    const regionalContentCardSlider = $('.section-regional-content .regional-content-card .slider');
    if (regionalContentCardSlider.length) {
      regionalContentCardSlider.each(function() {
        let _this = $(this);

        _this.on('init', function() {
          _this.nextAll('.slider-skeleton:first').hide();
        });

        _this.slick({
          dots: false,
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          swipe: false,
          mobileFirst: true,
          prevArrow: _this.parent('.preview-images').find('.prev'),
          nextArrow: _this.parent('.preview-images').find('.next'),
        });
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalRegionalContent.js